import { FC, ReactElement } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';
import { GeneratedLinkUrlObject } from 'src/utils/links';
import Constraints from '../../Constraints/Constraints';
import NavigationLink from '../../NavigationLink/NavigationLink';

const arrowIconBreadcrumbsBlue = 'shared/arrow-breadcrumbs-blue-light.svg';
const homeIcone = 'shared/home.svg';
const threeDotsIcon = 'shared/three_dots.svg';

export type BreadCrumbsItem = {
  id: string;
  title: ReactElement | string;
  href?: string | GeneratedLinkUrlObject;
};

interface Props {
  items: BreadCrumbsItem[];
}

export const BreadCrumbs: FC<Props> = ({ items }) => {
  const newItems = items?.slice(-2);

  return (
    <Constraints className="flex items-center px-5 xl:px-0 pt-5 pb-2">
      <div className="flex h-4.5 items-center">
        <div className="flex items-center mr-1">
          <NavigationLink href={'/'}>
            <NextImage
              alt="home icon"
              src={homeIcone}
              layout="fixed"
              width={18}
              height={18}
              priority
            />
          </NavigationLink>
        </div>

        <div className="hidden sm:flex">
          {items?.map((item, index) => {
            if (!item.title) return null;

            const Item = (
              <div
                key={index}
                className="flex fs-caption-m-reg text-darkBlue items-center justify-center mr-1"
              >
                <div className="mr-1">
                  <NextImage
                    alt="arrow"
                    src={arrowIconBreadcrumbsBlue}
                    layout="fixed"
                    height={8}
                    width={5}
                    priority
                  />
                </div>
                <p
                  className={cn('whitespace-nowrap opacity-60', {
                    'text-doveGray opacity-100': index === items?.length - 1
                  })}
                >
                  {item.title}
                </p>
              </div>
            );
            return index !== items?.length - 1 && item.href ? (
              <NavigationLink key={index} href={item.href}>
                {Item}
              </NavigationLink>
            ) : (
              Item
            );
          })}
        </div>
        <div className="flex sm:hidden items-center justify-center space-x-1">
          <div className=" flex items-center justify-center w-4.5 h-4.5 ">
            <NextImage
              alt="arrow"
              src={arrowIconBreadcrumbsBlue}
              layout="fixed"
              height={8}
              width={5}
              priority
            />
          </div>
          <div>
            <NavigationLink href={newItems[0].href}>
              <NextImage
                alt="three dots"
                src={threeDotsIcon}
                layout="fixed"
                width={18}
                height={18}
                priority
              />
            </NavigationLink>
          </div>
          <div className=" flex items-center justify-center  w-4.5 h-4.5">
            <NextImage
              alt="arrow"
              src={arrowIconBreadcrumbsBlue}
              layout="fixed"
              height={8}
              width={5}
              priority
            />
          </div>
          <div>
            <p className="fs-caption-m-reg text-doveGray line-clamp-1 text-ellipsis overflow-hidden">
              {newItems[1].title}
            </p>
          </div>
        </div>
      </div>
    </Constraints>
  );
};
